module.exports = __webpack_public_path__ + "static/media/youtube.96874e18.svg";